import React, { FC } from 'react';

import { Typography, useDesktop } from 'Modules/ui3';


export const AdditionaInfo: FC = () => {
    const isDesktop = useDesktop();

    return (
        <Typography fontSize={isDesktop ? '14px' : '12px'} color='grayscale.shade90'>
            © ООО «Блокчейн Хаб», оператор платформы ЦФА ХАБ,{' '}
            <a href='https://www.cbr.ru/finorg/foinfo/?ogrn=1217700447755' rel='noreferrer' target='_blank'>
                включен в реестр операторов информационных систем Банка России
            </a>.
            Экосистема ПАО «МТС»
        </Typography>
    );
};
